import * as MenuWrapper from './MenuWrapper'

export * from './MenuItemWrapper'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/menu' instead.
 */
export const Menu = MenuWrapper
